import Modal from '../ui/modal.js';
import User from './user.js';
import elements from '../utilities/elements.js';

function ManageCompanyUsersForm ( formEl, users, orgId ) {
  this.formEl = formEl;
  this.users = users;
  this.orgId = orgId;
  this.modal = new Modal( this.addNewUserForm() );

  this.createForm();
}

ManageCompanyUsersForm.prototype.createForm = function () {
  console.log(this.users);
  this.users.forEach( user => {
    let rowEl = document.createElement('div');
    //email
    let emailEl = document.createElement('p');
    emailEl.classList.add('user-email');
    let emailText = document.createTextNode( user.email );
    emailEl.appendChild( emailText );
    //name
    let nameEl = document.createElement('p')
    nameEl.classList.add('user-name');
    let nameText = document.createTextNode( user.name );
    nameEl.appendChild( nameText );
    //remove button
    let removeButton = document.createElement('button');
    let removeButtonText = document.createTextNode('Remove');
    removeButton.appendChild( removeButtonText );
    removeButton.addEventListener( 'click', e => { this.removeUser( user ) } );

    this.formEl.appendChild( nameEl );
    this.formEl.appendChild( emailEl );
    this.formEl.appendChild( removeButton );
  })
  //add button
  let addUserButton = document.createElement('button');
  let addUserButtonText = document.createTextNode('Add User');
  addUserButton.classList.add( 'add-user');
  addUserButton.appendChild( addUserButtonText );
  addUserButton.addEventListener( 'click', e => this.showAddUserForm() );

  this.formEl.appendChild( addUserButton );
};

ManageCompanyUsersForm.prototype.removeUser = function ( user ) {
  console.log(user);
  user.removeFromCompany()
  .then( result => {
    console.log(result);
    location.reload();
  })
};

ManageCompanyUsersForm.prototype.addUser = function (e) {
  e.preventDefault();

  let formInputs = e.target.elements;

  //disable form inputs and buttons during submit
  let buttons = e.target.getElementsByTagName('BUTTON');
  [...buttons].forEach( button => {
    button.disabled = true; 
  })
  let inputs = e.target.getElementsByTagName('INPUT');
  [...inputs].forEach( thisInput => {
    thisInput.disabled = true;
  })

  let newUser = new User( formInputs.useremail.value, formInputs.username.value, formInputs.orgid.value );

  newUser.addToCompany()
  .then( result => {
    console.log(result);
    location.reload();
  })
};

ManageCompanyUsersForm.prototype.showAddUserForm = function () {
  this.modal.showModal();
};

ManageCompanyUsersForm.prototype.addNewUserForm = function () {
  //elements
  let addUserForm = document.createElement('form');
  let emailInputGrp = elements.create.inputGroup( 'useremail', 'user-email-input', null, 'email', { required: true }, 'E-mail address' );
  let nameInputGrp = elements.create.inputGroup( 'username', 'user-name-input', null, 'text', { required: true }, 'Name' );
  let orgIdInput = elements.create.input( 'orgid', 'org-id-input', this.orgId, 'hidden', null );
  let submitButton = elements.create.button( 'Submit', 'submit', [] );
  elements.appendChildren( addUserForm, [emailInputGrp, nameInputGrp, orgIdInput, submitButton] );

  //functionality
  addUserForm.onsubmit = this.addUser;

  return addUserForm;
};

export default ManageCompanyUsersForm;
